var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesPageStarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 66,
    viewBox: "0 0 40 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3266 6.03475C29.7702 3.41873 31.3069 0.936152 31.74 0.518024C32.8437 -0.545839 34.8198 0.102128 35.6293 1.79217C36.0819 2.73731 35.722 4.35638 34.557 6.62494C33.593 8.50111 32.513 12.2012 32.1574 14.8471C31.4632 20.014 33.226 24.502 37.6799 28.9092C40.9771 32.1713 40.8025 33.5992 36.859 35.6308C30.5325 38.889 21.9275 50.3922 18.0685 60.75C16.2327 65.6788 15.9115 66.0369 13.805 65.5027C11.3784 64.8873 11.342 64.5572 12.3775 52.5004C13.1626 43.3633 9.42867 36.1633 3.75299 35.8694C2.11068 35.7844 0.915902 35.1207 0.376976 33.9961C-0.786954 31.5628 0.877344 29.6513 3.56634 30.3332C4.80763 30.648 6.63795 30.4228 7.63309 29.8331C13.7728 26.195 23.1587 15.4013 28.3266 6.03475Z",
    fill: "#72DB39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesPageStarImg);
export default __webpack_public_path__ + "static/media/services-page-star-img.8ba0285642d30141c28e6298bb46d686.svg";
export { ForwardRef as ReactComponent };